import { createStore, applyMiddleware, compose  } from 'redux';

import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';
import rootSagas from './sagas';


const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

const configureStore = () => {
  const store = createStore(
      rootReducer,
      compose(applyMiddleware(...middlewares)),
  );

  /*if (module.hot) {
    module.hot.accept('./reducers', () => {
      // eslint-disable-next-line global-require
      const nextRootReducer = require('./reducers');
      store.replaceReducer(nextRootReducer);
    });
  }
*/
  sagaMiddleware.run(rootSagas);
  return store;
};
const store = configureStore() // exported this instead;

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;